<template>
  <v-container :fluid="true" class="ma-0 pa-0 bg-light-blue">
    <Feedbacks
        v-if="$route.name === names.FEEDBACK.PAGE"
    />
    <router-view v-else />
  </v-container>
</template>

<script>
import { defineComponent } from 'vue'
import Feedbacks from "@/modules/personal_account/feedbacks/pages/Feedbacks.vue"
import names from "@/modules/personal_account/routers/names"

export default defineComponent({
  name: "FeedbacksBase",
  computed: {
    names () {
      return names
    }
  },
  components: { Feedbacks }
})
</script>

<style scoped lang="scss">

</style>
